// extracted by mini-css-extract-plugin
export default {"sectionHeader":"sectionHeader---1UVOC","sectionActions":"sectionActions---WJ9uu"};